import React, { Component } from "react";

import { Container, Row, Col } from "reactstrap";

import heroBgImg from "../../assets/images/man-queue.png";
import heroBgImgSmall from "../../assets/images/man-queue-small.jpg";

class Section extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.callModal.bind(this);
  }

  callModal = () => {
    this.refs.child.openModal();
  };

  render() {
    return (
      <React.Fragment>
        {/* HERO START */}

        {/* Mobile */}
        <section
          className="hero-3-bg-small position-relative d-block d-sm-none hero-pull-top"
          id="home"
          style={{ background: `url(${heroBgImgSmall}) center center no-repeat` }}
        >
          <div className="bg-dark-overlay" />
            <Container>
              <Row className="hero-info-holder-small">
                <Col lg={7} md={6} sm={8} xs={7} className="hero-info-small">
                  <div className="">
                    <p className="text-dark-gray f-14 mb-0 pb-0 blurp-small">
                      Dr. Derma is the largest dermatology network in SA
                    </p>
                    <h1 className="text-dark-gray hero-3-title-small">
                      Skip the queue & receive your treatment online
                    </h1>
                  </div>
                </Col>
              </Row>
            </Container>
        </section>

        {/* Desktop */}
        <section
          className="hero-3-bg position-relative d-none d-sm-block hero-pull-top"
          id="home"
          style={{ background: `url(${heroBgImg}) center center` }}
        >
          <div className="bg-dark-overlay" />
            <Container>
              <Row className="hero-info-holder" style={{width: '98%'}}>
                <Col lg={6} md={6} sm={6} xs={7} className="hero-info">
                  <div className="p-4 pt-5 mt-3 mb-3">
                    <p className="text-dark-gray f-14 mb-0 pb-0 blurp">
                      Dr. Derma is the largest dermatology network in South Africa
                    </p>
                    <h1 className="text-dark-gray hero-3-title mb-4">
                      Skip the queue & receive your treatment online
                    </h1>
                    <p className="mt-2 d-none d-md-block">
                      <a href="/consultation/start" className="btn btn-derma">Get started</a>
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
        </section>

        {/* HERO END  */}
      </React.Fragment>
    );
  }
}

export default Section;
